import { ReactElement } from 'react'

const PublicLayout = ({ children }: { children?: ReactElement }) => {
  return children
}

export default PublicLayout
